import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
/**
 * Modal :layout
 * desc: SelectBox Modal
 */
const SelectBoxLayout = ({ label, contentSet, viewStatus, onClickEvt, error,labelIcon,styleDef }) => {
  const set = '';
  return (
    <div className="_selectBox_modal_div"  style={styleDef}>
      {viewStatus === '_dim' ? <div className="_dim" /> : ''}
      <div className="_modal_tit_div">
        <div className="_icon">
          <i className={labelIcon} />
          <span className="_tit">{label}</span>
        </div>
        <div className="_close" onClick={onClickEvt}>
          <i className="ri-close-circle-line" style={{color:"#37b7ff"}}/>
        </div>
      </div>

      <div className="_content">{contentSet()}</div>
    </div>
  );
};

SelectBoxLayout.propTypes = {
  label: PropTypes.string,
  labelIcon: PropTypes.string,
  viewStatus: PropTypes.string,
  onClickEvt: PropTypes.func,
  contentSet: PropTypes.func,
  error: PropTypes.object,
  styleDef: PropTypes.object,
};
SelectBoxLayout.defaultProps = {
  label: '적용',
  styleDef: {},
  labelIcon: '',
  viewStatus: '',
  onClickEvt: () => {},
  contentSet: () => {},
  error: { error: false, msg: '' },
};

export default SelectBoxLayout;
